import { nullsToUndefined } from "../../../../null.js";
import { productCardCirRxjsConverter } from "../../../circuitos/product-card-cir-rxjs/converter.js";
import { productCardCruisesMobileConverter } from "../../../cruises/product-card-cruises/index.js";
import { productCardFliMobileConverter } from "../../product-card-fli/index.js";
import { productCardPackagesMobileConverter } from "../../../packages/product-card-packages/mobile/converter.js";
import { productCardHotelsMobileConverter } from "../../../product-card-hotels/index.js";
const genericProductCardConverter = (productCard)=>{
    if (productCard.name === 'm-product-card-he') return {
        ...productCard.props ?? productCard.data,
        soldOut: productCard.soldOut
    };
    if (productCard.name === 'm-product-card-packages') return productCardPackagesMobileConverter(productCard);
    if (productCard.name === 'm-product-card-hotels') return productCardHotelsMobileConverter(productCard);
    if (productCard.name === 'm-product-card-cir-rxjs') return productCardCirRxjsConverter(productCard);
    if (productCard.name === 'm-product-card-fli') return productCardFliMobileConverter(productCard);
    if (productCard.name === 'm-product-card-cruises') return productCardCruisesMobileConverter(productCard);
};
export const productCardListMobileConverter = (tabProduct)=>{
    const props = tabProduct.component?.props ?? tabProduct.component?.data ?? {};
    const items = props.items?.map(genericProductCardConverter).filter((item)=>!!item);
    return {
        config: {
            literals: {
                viewMore: nullsToUndefined(props?.link)?.content
            }
        },
        title: tabProduct.navigation?.content ?? '',
        link: props?.link?.href,
        items
    };
};
const generateAjaxComponentData = ({ data , navigation  })=>{
    const params = data?.Arguments?.map(({ Name , Value , Key =''  })=>({
            name: Name,
            key: Key,
            value: Value
        })) ?? [];
    return {
        title: navigation?.content ?? '',
        params
    };
};
export const tabProductCardMarketingMobileConverter = (tabProduct)=>{
    if ('component' in tabProduct) return productCardListMobileConverter(tabProduct);
    if ('data' in tabProduct) return generateAjaxComponentData(tabProduct);
};
export const tabsProductCardMarketingMobileConverter = (tabsProps)=>{
    const props = tabsProps?.props ?? {};
    const { items =[] , title ='' , config ={}  } = props ?? {};
    return {
        ...tabsProps,
        props: {
            ...props,
            config: {
                ...config,
                endpoint: config.endpoint
            },
            title,
            items: items.map(tabProductCardMarketingMobileConverter).filter((item)=>!!item)
        }
    };
};

//# sourceMappingURL=converter.js.map